import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";

export interface CareersForm {
  name: string;
  age: number;
  specialty: string;
  contact: string;
  email: string;
  degree: string;
  experience: string;
  status: number;
}

interface CareersFormState {
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: CareersFormState = {
  loading: false,
  error: null,
  success: false,
};

export const saveCareersFormDB = createAsyncThunk<
  CareersForm,
  {
    name: string;
    age: number;
    specialty: string;
    contact: string;
    email: string;
    degree: string;
    experience: string;
    status: number;
  }
>(
  "careersForm/saveCareersForm",
  async (
    { name, age, specialty, contact, email, degree, experience },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        name: name.trim(),
        age: Number(age),
        specialty: specialty.trim(),
        contact: contact.trim(),
        email: email.trim(),
        degree: degree.trim(),
        experience: experience.trim(),
        status: 1,
      };

      const response = await axiosInstance.post(
        "/doctor-request/create",
        payload
      );

      if (!response.data) {
        throw new Error("Invalid response from server");
      }
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.response?.data.message ||
          "Failed to submit application. Please try again."
      );
    }
  }
);

const careersFormSlice = createSlice({
  name: "careersForm",
  initialState,
  reducers: {
    clearCareersFormError: (state) => {
      state.error = null;
      state.loading = false;
    },
    resetCareersFormState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveCareersFormDB.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(saveCareersFormDB.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.success = true;
      })
      .addCase(saveCareersFormDB.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  },
});

export const { clearCareersFormError, resetCareersFormState } =
  careersFormSlice.actions;
export default careersFormSlice.reducer;

// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../axios/axiosInstance";

// export interface CareersForm {
//   id: number;
//   name: string;
//   age: number;
//   speciality: string;
//   contact: string;
//   email: string;
//   degree: string;
//   experience: string;
//   status_id: number;
// }

// interface CareersFormState {
//   loading: boolean;
//   error: string | null;
//   success: boolean;
// }

// const initialState: CareersFormState = {
//   loading: false,
//   error: null,
//   success: false,
// };

// export const saveCareersFormDB = createAsyncThunk<CareersForm, {
//     id?: number;
//     name: string;
//     age: number;
//     speciality: string;
//     contact: string;
//     email: string;
//     degree: string;
//     experience: string;
//     status_id: number;
//   }
// >(
//   "careersForm/saveCareersForm",
//   async (
//     {
//       name,
//       age,
//       speciality,
//       contact,
//       email,
//       degree,
//       experience,
//     },
//     { rejectWithValue }
//   ) => {
//     try {
//       const payload = {
//         name: name.trim(),
//         age: Number(age),
//         specialty: speciality.trim(),
//         contact: contact.trim(),
//         email: email.trim(),
//         degree: degree.trim(),
//         experience: experience.trim(),
//         status:1,
//       };

//       const response = await axiosInstance.post(
//         "/doctor-request/create",
//         payload
//       );

//       if (!response.data || !response.data.CareersForm) {
//         throw new Error("Invalid response from server");
//       }

//       return response.data.CareersForm;
//     } catch (error: any) {
//       console.error("Careers form submission error:", error);
//       return rejectWithValue(
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Failed to submit application. Please try again."
//       );
//     }
//   }
// );

// const careersFormSlice = createSlice({
//   name: "careersForm",
//   initialState,
//   reducers: {
//     clearCareersFormError: (state) => {
//       state.error = null;
//       state.loading = false;
//     },
//     resetCareersFormState: (state) => {
//       state.loading = false;
//       state.error = null;
//       state.success = false;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(saveCareersFormDB.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//         state.success = false;
//       })
//       .addCase(saveCareersFormDB.fulfilled, (state) => {
//         state.loading = false;
//         state.error = null;
//         state.success = true;
//       })
//       .addCase(saveCareersFormDB.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload as string;
//         state.success = false;
//       });
//   },
// });

// export const { clearCareersFormError, resetCareersFormState } = careersFormSlice.actions;
// export default careersFormSlice.reducer;
